import type { DOMProps } from "@simplybusiness/mobius";
import type { Ref } from "react";
import { useQuestionnaire } from "../../../../features/questionnaire";
import { useShouldBlockSubmission } from "../../../../hooks/useShouldBlockSubmission";
import { QuestionnaireActions } from "../QuestionnaireActions";
import type { BaseQuestionnaireActionsProps, ActionsElement } from "../index";

export type StackedQuestionnaireActionsProps = BaseQuestionnaireActionsProps &
  DOMProps & {
    /** Ref to the underlying HTMLDivElement */
    ref?: Ref<ActionsElement>;
  };
export type StackedQuestionnaireActionsRef = Ref<ActionsElement>;

/**
 * Stacked questionnaire actions variant with submit and back actions.
 */
export const StackedQuestionnaireActions = (
  props: StackedQuestionnaireActionsProps,
) => {
  const { submitActionLabel, redirectBackAction, backAction, ref } = props;

  // Access state via hooks
  const { errors } = useQuestionnaire();
  const shouldBlockSubmission = useShouldBlockSubmission();

  return (
    <QuestionnaireActions ref={ref} className="--stacked">
      {redirectBackAction && ( //TODO: remove redirectBackAction once backAction is updated in all usages, needed for now to avoid a breaking change
        <QuestionnaireActions.Back
          label={redirectBackAction.label}
          href={redirectBackAction.url}
        />
      )}
      {backAction &&
        !redirectBackAction && ( //TODO: for now legacy takes priority
          <QuestionnaireActions.Back
            label={backAction.label}
            href={backAction.url}
          />
        )}
      <QuestionnaireActions.Submit
        buttonLabel={submitActionLabel}
        isDisabled={shouldBlockSubmission}
        errors={errors}
      />
    </QuestionnaireActions>
  );
};
